import { render } from "./Camp.vue?vue&type=template&id=2b41cfca&scoped=true"
import script from "./Camp.vue?vue&type=script&lang=js"
export * from "./Camp.vue?vue&type=script&lang=js"

import "./Camp.vue?vue&type=style&index=0&id=2b41cfca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2b41cfca"

export default script